import styled, { keyframes, FlattenSimpleInterpolation } from "styled-components";
import Confetti from "react-confetti";

import StyledBoxTrayComponent from "../../atoms/MyOrder/StyledBoxTray";
import { colors, fonts } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

const viewSlidingUp = keyframes`
  from { transform: translateY(10%); }
  to { transform: translateY(0); }
`;

const fullViewSlidingUp = keyframes`
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
`;

const viewFadingIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const StyledRandomRewardsPopupContainer = styled(StyledBoxTrayComponent)`
  /* Enables horizontal scroll on responsive touch screens. */
  overflow-y: hidden;
  background-color: transparent;
  max-width: 840px;
  padding: 0;
  ${breakpoints.smDown} {
    top: 0;
    overflow-y: scroll;
    padding: 0;
    height: 100%;
  }
  ${breakpoints.smUp} {
    top: 52.5%;
    right: 50%;
    height: 460px;
    transform: translate(50%, -50%);
  }
  ${breakpoints.mdUp} {
    height: 460px;
    padding: 0;
  }
`;

export const VerticalAnimatingContainer = styled.div`
  height: 100%;
  ${breakpoints.smUp} {
    animation: ${viewSlidingUp} 0.8s ease-out;
  }
  ${breakpoints.smDown} {
    animation: ${fullViewSlidingUp} 0.8s ease-out;
  }
`;

export const FadingAnimatingContainer = styled.div<{ backgroundColor: string }>`
  background-color: ${(props) => props.backgroundColor};
  z-index: 1;
  animation: ${viewFadingIn} 1s ease-out;
  padding: 30px 15px;
  ${breakpoints.smDown} {
    top: 0;
    overflow-y: scroll;
    padding-top: 15px;
    min-height: 100% !important;
  }
  ${breakpoints.mdUp} {
    padding: 30px;
  }
`;

export const CloseButton = styled.img`
  width: 15px;
  height: 15px;
  cursor: pointer;
  z-index: 5;
`;

export const PointsDot = styled.div`
  height: 10px;
  width: 10px;
  background-color: ${colors.coral};
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
  margin-bottom: 2px;
`;

export const PointsLabel = styled.label`
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 20px;
  color: ${colors.black};
  ${breakpoints.smUp} {
    display: none;
  }
`;

export const TopBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  z-index: 5;
`;

export const StyledTitle = styled.h2<{
  textAlign: string;
  customStyle?: FlattenSimpleInterpolation;
}>`
  margin-top: 40px;
  font-size: 45px;
  line-height: 0.9;
  text-transform: uppercase;
  text-align: left;
  font-family: ${fonts.fontInterstateUltraBlack};
  margin-bottom: 16px;
  ${breakpoints.smDown} {
    font-size: 35px;
  }
  ${breakpoints.xsDown} {
    text-align: ${(props) => props.textAlign};
    font-size: 35px;
    margin-top: 0px;
  }
  ${breakpoints.smUp} {
    max-width: 530px;
  }
  ${(props) => props.customStyle};
`;

export const DescriptionAndImageContainer = styled.div`
  display: flex;
  flex: 1;
  flex-flow: row nowrap;
  width: 100%;
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex: 0.5;
  flex-direction: column;
  padding-right: 15px;
`;

export const DescriptionText = styled.p<{ textAlign: string }>`
  font-size: 18px;
  line-height: 24px;
  font-family: ${fonts.fontBauRegular};
  text-align: "left";
  margin-bottom: 24px !important;
  ${breakpoints.smDown} {
    margin-bottom: 80px !important;
  }
  ${breakpoints.xsDown} {
    text-align: ${(props) => props.textAlign};
  }
`;

export const ImageContainer = styled(DescriptionContainer)`
  padding-right: 0px;
`;

export const ConfettiAndImageWrapper = styled.div`
  position: relative;
  z-index: 0;
`;

export const StyledConfettiWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
`;

export const StyledConfetti = styled(Confetti)`
  height: 100%;
  width: 100%;
  z-index: 0;
  margin-top: -50px;
  ${breakpoints.smDown} {
    margin-top: 0px;
  }
`;
